import App from 'app/app.js';

function LtPayOnlySummaryCtrl($scope, $timeout) {
  this.init = function () {
    $timeout(function () {
      if ($scope.isScrollable) {
        $('#sticky-float').stickyfloat({
          duration: 0,
          offsetY: 0,
          parent: $('#auto-scroll')
        });
      }
    });
  };

  this.submitOrder = function () {
    $scope.onSubmit();
  };
}

App.controller('LtPayOnlySummaryCtrl', ['$scope', '$timeout', LtPayOnlySummaryCtrl]);
